import React from 'react';
import PropTypes from 'prop-types';

import applySkeleton from '../../../../../hocs/applySkeleton';

const DetailsHeader = ({ text, theme }) => (
    <h3 className={ theme.detailsHeader }>
        {text}
    </h3>
);

DetailsHeader.propTypes = {
    theme: PropTypes.shape({}),
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
};

export default applySkeleton(DetailsHeader);
